import { CommonArticleProps } from './../models/Article';
import axios from 'axios';
import { Article, ArticleForm, ArticleMode, RubriqueWithArticle } from 'core/models';
import { EditorSettings } from 'tinymce';

type BlobInfo = Parameters<EditorSettings['images_upload_handler']>[0];

export type ArticleFilters = {
    search?: string;
    tags?: number[];
};

export function getArticles(mode: ArticleMode, filters?: ArticleFilters) {
    return axios.get<Article[]>(`/${mode}/`, {
        params: {
            tags: filters?.tags && filters.tags.length ? JSON.stringify(filters?.tags) : undefined,
            search: filters?.search || undefined,
        },
    });
}

export function getLastArticle() {
    return axios.get<CommonArticleProps[]>(`/articles/latest`).then((data) => {
        return data;
    });
}

export function getArticlesAdmin(mode: ArticleMode) {
    return axios.get<Article[]>(`/${mode}/admin`);
}

export function getRubriquesWithArticles(mode: ArticleMode, filters?: ArticleFilters) {
    return getArticles(mode, filters).then((articles) => {
        return (articles as Article[]).reduce((result, article) => {
            let rubrique = result.find((r) => r.id === article.rubrique.id);

            if (!rubrique) {
                rubrique = {
                    ...article.rubrique,
                    articles: [],
                };
                result.push(rubrique);
            }

            rubrique.articles.push(article);

            return result;
        }, [] as RubriqueWithArticle[]);
    });
    // return axios.get<RubriqueWithQuestion[]>('/rubrique/articles');
}

// TODO: à voir si encore nécessaire une fois l'api stabilisée...
const toExpectedArticleData = (article: ArticleForm) => ({
    ...article,
    rubriqueOrder: 1,
    tags: article.tags?.reduce(
        (prev, tag, idx) => ({
            ...prev,
            [idx.toString()]: tag,
        }),
        {},
    ),
});

export function createArticle(mode: ArticleMode, article: ArticleForm) {
    const expectedArticle = toExpectedArticleData(article);
    const data = new FormData();
    data.append('thumbnailImage', expectedArticle.thumbnailImage);
    Object.keys(expectedArticle)
        .filter((key) => key !== 'thumbnailImage')
        .forEach((key) => data.append(key, JSON.stringify(expectedArticle[key])));
    return axios.post(`/${mode}/`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export async function uploadArticleImage(mode: ArticleMode, articleId: number, blobInfo: BlobInfo) {
    const data = new FormData();
    data.append('file', blobInfo.blob(), blobInfo.filename());

    const result = await axios.post(`/${mode}/image/upload/${articleId}/`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    return result[0] as string;
}

export function editArticle(mode: ArticleMode, id: number, article: ArticleForm) {
    const expectedArticle = toExpectedArticleData(article);
    const data = new FormData();
    data.append('thumbnailImage', expectedArticle.thumbnailImage);
    Object.keys(expectedArticle)
        .filter((key) => key !== 'thumbnailImage')
        .forEach((key) => data.append(key, JSON.stringify(expectedArticle[key])));
    // FIXME: à cause de Symfony 4, on ne peut pas faire de multipart/form-data dans un put
    // Donc on doit faire un post avec en params '_method': 'PUT'
    return axios.post(`/${mode}/edit/${id}/`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: { _method: 'PUT' },
    });
}

export function getArticle(mode: ArticleMode, id: number) {
    return axios.get<Article>(`/${mode}/${id}/`);
}

export function getArticleBySlug(mode: ArticleMode, slug: string) {
    return axios.get<Article>(`/${mode}/slug/${slug}/`);
}

// TODO : Delete????
export function deleteActualite(mode: ArticleMode, id: number) {
    return axios.delete(`/${mode}/remove/${id}/`);
}
